<template>
  <v-dialog
    eager
    width="800"
    v-model="dialog"
  >
    <v-card>
      <v-card-title>
        <v-col class="text-right px-4">
          <v-btn icon @click="dialog=false">
            <v-icon large color="primary">close</v-icon>
          </v-btn>
        </v-col>
      </v-card-title>

      <v-card-text>
        <vue-json-pretty :path="'res'" :data="data" > </vue-json-pretty>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          {{ $t('buttons:close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LogsService from '@/modules/display/services/logs-service';
import Utils from '@/modules/core/services/utils';

import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default {
  name: "JsonLogShow",
  components: {
    VueJsonPretty
  },
  data() {
    return {
      currentItem: null,
      dialog: false,
      data: {}
    }
  },
  methods: {
    initialization(item) {
      this.currentItem = item;

      LogsService.getJsonLog(item.jsonId,
        (response) => {
          this.data = JSON.parse(response.data.json);
          this.dialog = true;
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/logs:advert.json')}));
        }
      )
    }
  }
}
</script>
